<template>
  <div id="contenedor-auditorias-contratos-picker">
    <v-col
    :cols="cols"
    :sm="sm"
    :md="md"
    :lg="lg">
    <v-autocomplete
      v-model="contratosSeleccionados"
      :label="getLabel"
      :items="getContratos"
      return-object
      :multiple="multiSelect"
      filled
      clearable
      :disabled="isDisabled"
      color="#6A83B5"
      background-color="#F2F6FF"
      item-text="numero"
      :filter="filtro"
      :search-input.sync="search"
      @change="enviarSeleccionados">
      <template
        v-slot:item="data">
        <v-list-item-content>
          <v-list-item-title>
            {{ data.item.numero }} - {{data.item.contratista.trim().slice(0,20)}}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ data.item.meta.slice(0,40) }}...
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
    </v-col>
  </div>
</template>

<script>
import AUDITORIAS_CONTRATOS from '@/graphql/querys/administracion/auditorias/auditoriasContratos.gql';

export default {
  name: 'AuditoriasContratosPicker',
  data() {
    return {
      contratosSeleccionados: [],
      search: '',
    };
  },
  props: {
    multiSelect: {
      type: Boolean,
      required: false,
      default: true,
    },
    cols: {
      type: String,
      default: '12',
    },
    sm: {
      type: String,
      default() {
        return this.sm || this.cols;
      },
    },
    md: {
      type: String,
      default() {
        return this.md || this.sm;
      },
    },
    lg: {
      type: String,
      default() {
        return this.lg || this.md;
      },
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    filtro(item, queryText) {
      const numero = item.numero.toLowerCase();
      const meta = item.meta.toLowerCase();
      const expt = new RegExp(queryText, 'gi');
      return expt.test(numero) || expt.test(meta);
    },
    enviarSeleccionados() {
      // V-MODEL
      this.$emit('input', this.contratosSeleccionados);
      // ENVIAR SOLO IDS SELECCIONADOS
      if (this.multiSelect === true) {
        this.$emit('solo-ids', this.contratosSeleccionados.map((contrato) => contrato.id));
      } else if (this.contratosSeleccionados !== null) {
        this.$emit('solo-ids', [this.contratosSeleccionados.id]);
      } else {
        this.$emit('solo-ids', []);
      }
      // this.contratosSeleccionados = [];
    },
  },
  apollo: {
    auditoriasContratos: {
      query: AUDITORIAS_CONTRATOS,
      variables() {
        return {
          idAuditoria: this.$route.params.idAuditoria,
        };
      },
    },
  },
  computed: {
    getLabel() {
      if (this.multiSelect === true) return 'Seleccionar contrato(s)';
      return 'Seleccionar contrato';
    },
    getContratos() {
      if (!this.auditoriasContratos) return [];
      return this.auditoriasContratos
        .map((contrato) => ({
          id: contrato.contrato ? contrato.contrato.id : '',
          numero: contrato.contrato ? contrato.contrato.numero : '',
          ejercicio: contrato.contrato ? contrato.contrato.ejercicio : '',
          meta: contrato.contrato ? contrato.contrato.meta : '',
          contratista: contrato.contrato ? contrato.contrato.contratista.nombreRazonSocial : '',
        }))
        .sort((a, b) => (`${a.numero}`).localeCompare(b.numero));
    },
  },
  watch: {
    contratosSeleccionados() {
      this.search = '';
    },
  },
};
</script>

<style lang="scss">
</style>
